import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    valid_modal_background: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.25)',
        backdropFilter: 'blur(3px)',
        zIndex: 3,
    },
    valid_modal: {
        width: 'auto',
        height:'auto',
        minWidth: '340px',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        zIndex: 5,
        backgroundColor: 'white',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        transition: 'flex-grow 1000ms linear',
        animation: 'slide-in-modal 0.5s forwards',
        alignItems: 'center',
    },
    valid_modal_frame: {
        minHeight: '620px',
    },
    valid_modal_withSideBar: {
        width: '768px',
    },
    valid_modal_withSideBarEmbeded: {
        width: '100% !important',
    },
    valid_modal_inner: {
        display: 'flex',
        margin: '0 auto',
        width: '100%',
        height: 'auto',
        flexGrow: 1,
    },
    valid_modal_inner_left: {
        background: '#f8f8f8',
        width: '30%',
        flexGrow: 1,
        padding: '20px',
    },
    valid_modal_inner_right: {
        background: '#ffffff',
        flexGrow: 1,
        padding: '10px',
    },
    changeCard: {
        background: '#f8f8f8',
        border: '1px solid #ccc',
        transition: 'all 200ms linear',
        cursor: 'pointer',
        marginTop: '20px',
        display: 'inline-flex',
        borderRadius: '4px',
        padding: '6px',
        fontSize: 'var(--fs_medium)',
        '&:hover': {
            background: '#ffffff',
            border: '1px solid #000',
        },
    },
    threeDsFrame: {
        width: '100%',
        height: '100%',
        margin: '0 auto',
        overflow: 'hidden',
    },
    label: {
        fontSize: theme.spacing(1.5),
        textTransform: 'none',
        fontWeight: 600
    },
    fullModalSize: {
        width: '95%',
        height: '95%',
    },
    fullModal_modal_inner_left: {
        width: '15%',
    },
    fullModal_modal_inner_right: {
        width: '100%',
    },
}));

export default useStyles;
